module.exports = __webpack_public_path__ + "static/media/r3.2a03133d.jpg";